import { createCustomerAddressPairInputSchema } from './create-address-pair-input.js';
import { customerAddressPairFormSchema, } from './create-pair-form.js';
export function toCreateCustomerAddressPairInput(values) {
    const parsed = customerAddressPairFormSchema.parse(values);
    const billingSameAsShipping = parsed.billingSameAsShipping !== false;
    return createCustomerAddressPairInputSchema.parse({
        shipping: {
            addressName: parsed.addressName,
            address: parsed.address,
            city: parsed.city ?? null,
            stateId: parsed.stateId ?? null,
            countryId: parsed.countryId ?? null,
            zip: parsed.zip ?? null,
        },
        billingSameAsShipping,
        // The pair form's superRefine rejects an incomplete billing whenever it isn't same-as-shipping.
        billing: billingSameAsShipping ? null : parsed.billing,
    });
}
//# sourceMappingURL=to-create-customer-address-pair-input.js.map